// **************************

// NOTE: THIS IS A FORK OF https://github.com/gre/react-gl-transition
// WITH NULL-GUARD ON setProgress TO PREVENT CRASH WHEN THE NODE IS UNMOUNTED

// **************************

import React, { Component } from 'react'
import { Node, connectSize } from 'gl-react'

export default connectSize(
  class GLTransition extends Component {

    render() {
      const { transition: { glsl }, progress } = this.props

      return (
        <Node
          ref={node => { this.node = node }}
          shader={{
            frag: `
precision highp float;
varying vec2 uv;
uniform float progress, ratio;
uniform sampler2D from, to;
vec4 getFromColor(vec2 uv){return texture2D(from, uv);}
vec4 getToColor(vec2 uv){return texture2D(to, uv);}
${glsl}
void main(){gl_FragColor=transition(uv);}`,
          }}
          ignoreUnusedUniforms={[ 'ratio' ]}
          uniforms={this.getUniformsWithProgress(progress)}
        />
      )
    }

    getUniformsWithProgress(progress) {
      const {
        transition: { defaultParams },
        transitionParams,
        from,
        to,
        width,
        height,
      } = this.props

      return {
        ...defaultParams,
        ...transitionParams,
        progress,
        from,
        to,
        ratio: width / height,
      }
    }

    setProgress = progress => {
      if (this.node) {
        this.node.setDrawProps({
          uniforms: this.getUniformsWithProgress(progress),
        })
      }
    }

  }
)
